import { useState } from 'react'
import Icon from '@components/Icon'
import classnames from 'classnames'
import styles from './styles.module.scss'
import ToggleSwitch from '@components/ToggleSwitch'

const DetailedCookiesItem = ({ title, toggleEnable, enabled, children }) => {
    const [expanded, setExpanded] = useState(false)

    return (
        <div
            className={classnames(styles.detailedCookieItem, {
                [styles.withoutToggle]: !toggleEnable,
            })}>
            <div className={classnames(styles.detailedCookieItemLeft)} onClick={() => setExpanded(!expanded)}>
                <div>
                    <Icon
                        type="arrow-left"
                        className={classnames(styles.expandArrow, { [styles.expanded]: !!expanded })}
                    />
                </div>
                <div className="ml-3">
                    <span>{title}</span>
                    {expanded && <div className={classnames('mb-3', 'mt-2', styles.cookieText)}>{children}</div>}
                </div>
            </div>
            <div className={classnames(styles.detailedCookieItemRight)}>
                {toggleEnable ? (
                    <ToggleSwitch
                        id={title}
                        checked={enabled}
                        onChange={toggleEnable}
                        className="d-flex justify-content-end"
                    />
                ) : (
                    <T>cookie.modal.label.always.active</T>
                )}
            </div>
        </div>
    )
}

export default DetailedCookiesItem
